import { createProvider } from '@frontend/store';
import { TemplatesV2StoreState, TemplatesV2Store } from './type';

const INITIAL_STATE: TemplatesV2StoreState = {
  paymentsEnabledLocationIdsMap: {},
  isPaymentsOnboardingCheckComplete: false,
};

export const { Provider: TemplatesV2StoreProvider, useStore: useTemplatesV2Store } = createProvider<TemplatesV2Store>()(
  (set) => ({
    ...INITIAL_STATE,
    setPaymentsEnabledLocationIdsMap: (value) => {
      set({ paymentsEnabledLocationIdsMap: value });
    },
    setIsPaymentsOnboardingCheckComplete: (value) => {
      set({ isPaymentsOnboardingCheckComplete: value });
    },
  })
);
